const R = (typeof window!=='undefined' && window.React) || {};
export default R;
export const Children = R.Children;
export const Component = R.Component;
export const Fragment = R.Fragment;
export const createElement = R.createElement;
export const cloneElement = R.cloneElement;
export const createContext = R.createContext;
export const forwardRef = R.forwardRef;
export const memo = R.memo;
export const startTransition = R.startTransition;
export const isValidElement = R.isValidElement;
export const useEffect = R.useEffect;
export const useLayoutEffect = R.useLayoutEffect;
export const useMemo = R.useMemo;
export const useState = R.useState;
export const useRef = R.useRef;
export const useCallback = R.useCallback;
export const useContext = R.useContext;
export const useReducer = R.useReducer;
export const useId = R.useId;
export const useSyncExternalStore = R.useSyncExternalStore;
